import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field } from "./ImageField";

export const SettingsTab = () => {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("New password must be at least 8 characters");
      return;
    }
    if (next !== confirm) {
      toast.error("New passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed successfully");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-settings" className="max-w-lg">
      <h1 className="font-heading text-2xl font-bold tracking-tight text-ink">Settings</h1>
      <p className="mt-1 font-body text-sm text-steel">
        Signed in as <span className="font-semibold text-ink">{user?.email}</span>
      </p>

      <form onSubmit={submit} className="mt-8 space-y-4 rounded-xl border border-steel/20 bg-aero-surface p-6">
        <div className="mb-2 flex items-center gap-2">
          <KeyRound className="h-4 w-4 text-saffron" />
          <h2 className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-saffron">Change Password</h2>
        </div>
        <Field label="Current password" type="password" value={current} testId="settings-current-password" onChange={setCurrent} />
        <Field label="New password (min 8 characters)" type="password" value={next} testId="settings-new-password" onChange={setNext} />
        <Field label="Confirm new password" type="password" value={confirm} testId="settings-confirm-password" onChange={setConfirm} />
        <button
          data-testid="settings-change-password-btn"
          type="submit"
          disabled={busy || !current || !next || !confirm}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-saffron py-3 font-heading text-sm font-semibold text-white transition-colors hover:bg-saffron-soft disabled:opacity-60"
        >
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}
          Update Password
        </button>
      </form>
    </div>
  );
};
